import * as React from 'react'
import { Button, ButtonText } from '../ui/button'
import useAppStore from '@/store/useAppStore'
import NonModalWindow from '@/components/NonModalWindow'
import useOpenModalWindow from '../../hooks/useOpenModalWndow'
import { MODAL_WINDOW_TYPE } from '@/data/constants/constants'
import { Separator } from '../ui/separator'
import { SearchIcon } from 'lucide-react'
import { TextField } from '../ui/TextField'
import { useState } from 'react'
import useGetModelsList from '@/services/api/model/useGetModelsList'
import {
  ArrowTopRightOnSquareIcon,
  InboxIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid'
import { Switch } from '../ui/switch'
import useEnableModel from '@/services/api/model/useEnableModel'
import useDisableModel from '@/services/api/model/useDisableModel'
import { NON_MODAL_WINDOW_TYPE } from '@/data/constants/constants'
import useOpenNonModalWndow from '@/hooks/useOpenNonModalWndow'
import { useNavigate } from 'react-router-dom'
import useCloseToOrigin from '@/hooks/useCloseToOrigin'
import CreateModel from './CreateModel'

export default function Models() {
  const toggleNonModalWindow = useAppStore(
    (state) => state.toggleNonModalWindowState,
  )
  const { openModal } = useOpenModalWindow()
  const [searchTerm, setSearchTerm] = useState('')
  const { data: modelsList } = useGetModelsList()
  const [models, setModels] = useState(modelsList)
  const [loading, setLoading] = useState(true)
  const { mutate: enableModel } = useEnableModel()
  const { mutate: disableModel } = useDisableModel()
  const { open } = useOpenNonModalWndow()
  const [openCreateModel, setOpenCreateModel] = useState(false)
  const navigate = useNavigate()

  const closeToOrigin = useCloseToOrigin()
  // const modelsList = {
  //         length: 0,
  // }

  React.useEffect(() => {
    if (modelsList) {
      setModels(modelsList)
      setLoading(false)
    }
  }, [modelsList])

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value)
  }

  const toggleModel = (model) => {
    setModels((prevModels) =>
      prevModels.map((e) =>
        e.id === model.id ? { ...e, is_enabled: !e.is_enabled } : e,
      ),
    )
    model.is_enabled ? disableModel(model.id) : enableModel(model.id)
  }

  const filteredModels = models?.filter(
    (model) =>
      model.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (model.description &&
        model.description.toLowerCase().includes(searchTerm.toLowerCase())),
  )

  if (loading) {
    return null
  }

  return (
    <>
      <CreateModel
        open={openCreateModel}
        setOpen={setOpenCreateModel}
        key={openCreateModel ? 'create-model' : 'close-create-model'}
      />
      <NonModalWindow
        onClose={() => {
          closeToOrigin()
        }}
      >
        <NonModalWindow.Header className="h-[108px]">
          <div className="flex flex-1 flex-col gap-2">
            <div className="flex flex-row justify-between">
              <p>Models</p>
              <Button
                type="button"
                iconOnly
                variant="ghost"
                onClick={() => closeToOrigin()}
                size="sm"
                className="size-7 self-start"
              >
                <XMarkIcon />
              </Button>
            </div>

            <TextField.Input
              placeholder="Search"
              leadingIcon={<SearchIcon className="" />}
              value={searchTerm}
              onChange={handleInputChange}
            />
          </div>
        </NonModalWindow.Header>

        <NonModalWindow.Body className="min-h-[78vh] p-0">
          {searchTerm && filteredModels?.length == 0 && (
            <div className="flex justify-center pt-8">
              <div className="flex flex-col items-center p-4 text-txt-secondary">
                <SearchIcon />
                <p className="max-w-[292px] break-words text-center">
                  No results found for "
                  <span className="max-h-full font-semibold">{searchTerm}</span>
                  "
                </p>
              </div>
            </div>
          )}

          {!searchTerm && filteredModels?.length < 1 && (
            <div className=" flex flex-col items-center p-4 pt-8 text-txt-secondary">
              <InboxIcon className="size-5" />
              <p className="max-w-[292px] break-words text-center">No Models</p>
            </div>
          )}
          {models?.length > 0 && (
            <div>
              {filteredModels?.map((model) => (
                <div key={model.id} className="flex flex-col">
                  <div className="flex justify-between p-4">
                    <div className="flex gap-3">
                      <Switch
                        checked={model.is_enabled}
                        onCheckedChange={() => toggleModel(model)}
                      />
                      <div>
                        <p className="text-txt-primary">{model.name}</p>
                        {model.description && (
                          <div className="text-xs text-txt-secondary">
                            {model.description}
                          </div>
                        )}
                      </div>
                    </div>

                    <Button
                      variant="ghost"
                      iconOnly
                      onClick={
                        () => navigate(`/models/${model.id}/transactions`)
                        //   open({
                        //     name: NON_MODAL_WINDOW_TYPE.MODELS_WINDOW,
                        //   })
                      }
                    >
                      <ArrowTopRightOnSquareIcon className="size-4" />
                    </Button>
                  </div>
                  <Separator />
                </div>
              ))}
            </div>
          )}
        </NonModalWindow.Body>
        <NonModalWindow.Footer>
          <Button type="submit" onClick={() => setOpenCreateModel(true)}>
            <ButtonText>Create New Model</ButtonText>
          </Button>
        </NonModalWindow.Footer>
      </NonModalWindow>
    </>
  )
}
